import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MaskedLine, EASE } from "@/components/Reveal";
import { scrollToId } from "@/lib/lenis";

const HERO_IMG =
  "https://images.unsplash.com/photo-1612544409025-e1f6a56c1152?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBmaWxtJTIwY2FtZXJhJTIwcHJvZHVjdGlvbiUyMHNldCUyMHN0dWRpbyUyMG1vdmllJTIwY3Jld3xlbnwwfHx8YmxhY2t8MTc5MTg5MTA0N3ww&ixlib=rb-4.1.0&q=85";

export default function GoshtaHero() {
  return (
    <section id="top" data-testid="goshta-hero" className="relative min-h-screen overflow-hidden">
      <motion.div
        className="absolute inset-0"
        initial={{ scale: 1.12, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 2.2, ease: EASE }}
      >
        <img src={HERO_IMG} alt="" className="h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-[#050505]" />
      </motion.div>

      <div className="relative mx-auto flex min-h-screen max-w-[1440px] flex-col justify-end px-5 pb-20 pt-32 md:px-10 md:pb-28">
        <MaskedLine delay={0.1}>
          <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-[#D4AF37]">
            Pan-India Production Network
          </p>
        </MaskedLine>
        <MaskedLine delay={0.2} className="mt-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">
            Goshta — The Writer Room Productions · Production meets Storytelling
          </p>
        </MaskedLine>

        <h1 className="mt-8 font-display text-4xl font-medium leading-[1.05] tracking-tight text-neutral-100 sm:text-5xl lg:text-6xl">
          <MaskedLine delay={0.35}>Every Thought Can</MaskedLine>
          <MaskedLine delay={0.5}>
            <em className="italic text-[#D4AF37]">Become a Story.</em>
          </MaskedLine>
        </h1>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.75, ease: EASE }}
          className="mt-8 max-w-2xl text-base leading-relaxed text-neutral-300 sm:text-lg"
        >
          Complete line production services across India, alongside a writers&rsquo; network that
          can take an idea from concept to story, screenplay and dialogue—ready to be developed
          for film, series and commercial projects.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.95, ease: EASE }}
          className="mt-10 flex flex-wrap items-center gap-4"
        >
          <button
            data-testid="hero-explore-production"
            onClick={() => scrollToId("#production")}
            className="inline-flex items-center gap-2 bg-[#B79045] px-7 py-4 font-mono text-[11px] uppercase tracking-[0.2em] text-black transition-colors duration-300 hover:bg-[#D4AF37]"
          >
            Explore Production <ArrowUpRight size={14} />
          </button>
          <button
            data-testid="hero-develop-story"
            onClick={() => scrollToId("#stories")}
            className="inline-flex items-center gap-2 border border-[#B79045]/60 px-7 py-4 font-mono text-[11px] uppercase tracking-[0.2em] text-[#D4AF37] transition-colors duration-300 hover:bg-[#B79045] hover:text-black"
          >
            Develop a Story <ArrowUpRight size={14} />
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.3 }}
          className="mt-14 flex flex-col gap-1 border-t border-white/10 pt-6 sm:flex-row sm:items-baseline sm:gap-6"
        >
          <p className="font-display text-xl italic text-neutral-200">One creative partner.</p>
          <p className="text-sm text-neutral-500">
            On-ground execution and stories designed to connect.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
